import { Http, EndPoints, getParams, TypeParams, TypeResource, CompanyID, parseParametersToSendBackend } from '../../core/utils';
import { DynamicFieldsResponse } from '../models';


export const CustomFrontendServices = {

    getAllDynamicFields: () : Promise<DynamicFieldsResponse> =>
        // Http.get(`${TypeResource.CUSTOM_FRONTEND}${EndPoints.CustomFrontendUrls.GET_DYNAMIC_FIELDS}`)
        Http.get(`${TypeResource.CUSTOM_FRONTEND}${EndPoints.CustomFrontendUrls.GET_DYNAMIC_FIELDS}`)
        .then(response => response.data),

};

const joinParams = (ids: CompanyID[] | string[], separator: string) => ids.join(separator);
